export default {
  data() {
    return {
      offerTypesConst: [
        {label: this.$t('crm.formule_all_inclusive'), value: 'OFFER1'},
        {label: this.$t('crm.formule_confort'), value: 'OFFER2'},
        {label: this.$t('crm.formule_online'), value: 'OFFER3'},
      ],
    };
  },
  methods: {
    displayForOfferTypeConst(value) {
      let result = this.offerTypesConst.find((el) => el.value === value);
      return result ? result.label : '';
    },
  },
  computed: {
    offerTypesConstAlphabetical() {
      return this.offerTypesConst.sort((a, b) => {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      });
    },
  },
};
